import type { EvidenceStatus } from '../form/types';

/** Returns true when a status should display the “Needs more detail” indicator. */
export const isNeedsMoreDetail = (value: EvidenceStatus): boolean => {
  if (!value) return false;
  const { status, notes } = value;
  const hasNotes = Boolean(notes && notes.trim());

  if (status === 'UNCERTAIN') return true;
  if (status === 'EXISTS_NOT_HAVE') return !hasNotes;
  return false;
};

/**
 * Returns true if ANY row in the provided map needs more detail.
 * Accepts the frontend evidenceStatuses object (string → EvidenceStatus).
 */
export const hasAnyNeedsMoreDetail = (
  statuses: Record<string, EvidenceStatus | undefined> | undefined,
): boolean => {
  if (!statuses) return false;
  return Object.values(statuses).some(
    (value) => Boolean(value) && isNeedsMoreDetail(value as EvidenceStatus),
  );
};
